// @flow

import { type IncomingPayment } from './types';

export function getAmountUsd(incomingPayment: IncomingPayment): number {
  return incomingPayment['amount_usd'];
}
